import ImageGallery from "@components/molecules/GalleryView";
import { ImageObject } from "@components/molecules/GalleryView/utils/types";
import React, { useCallback, useRef, useState } from "react";
import { css, useTheme } from "styled-components/native";
import styled from "styled-components/native";
import Footer from "./Footer";
import { GalleryCategory } from "@components/molecules/GalleryView/utils/GalleryType";
import { Diamond } from "@src/types/DiamondDetail";
import { Platform } from "react-native";
import { SpaceType } from "@components/atoms/Spacer/types";
import { useNativeShare } from "@components/molecules/Share/utils/utils";

export interface PDPGalleryProps {
  ReceivedDiamondData?: any;
  itemDetail?: Diamond;
  productType?: string;
  screenWidth?: number;
  imageWidth?: number;
  showExpandButton?: boolean;
  dimensions?: any;
  setMediaActiveIndex?: any;
  hideThumbs?: boolean;
  mediaActiveIndex?: number;
  fromReviewPage?: boolean;
  isJewelryComponent?: boolean;
  onRemoveMedia?: (index: number, media_id: number) => void;
  isModal?: boolean;
  hideMediaActions?: boolean;
}

const PDPGalleryView = ({
  ReceivedDiamondData,
  itemDetail,
  productType,
  screenWidth,
  imageWidth,
  showExpandButton = true,
  dimensions,
  setMediaActiveIndex,
  hideThumbs = false,
  mediaActiveIndex,
  fromReviewPage,
  isJewelryComponent,
  onRemoveMedia,
  isModal,
  hideMediaActions,
}: PDPGalleryProps) => {
  const theme = useTheme();
  const [leftCurrentIndex, setLeftCurrentIndex] = useState(0);

  const { handleShareViaNative } = useNativeShare(itemDetail);
  const handleShareViaNativeRef = useRef(handleShareViaNative);

  React.useEffect(() => {
    handleShareViaNativeRef.current = handleShareViaNative;
  }, [handleShareViaNative]);

  const onShareViaNativeFromModal = useCallback((mediaUrl: string) => {
    if (Platform.OS === "web") return;
    setTimeout(() => {
      handleShareViaNativeRef.current(mediaUrl);
    }, 600);
  }, []);

  let actualImageWidth;
  if (theme.isLargeScreen) {
    actualImageWidth = imageWidth;
  } else {
    actualImageWidth = Math.max(
      0,
      (imageWidth ?? 0) - (theme.isLargeScreen ? 75 : 0)
    );
  }

  const renderFooterComponent = (image: ImageObject, currentIndex: number) => {
    setMediaActiveIndex?.(currentIndex);
    return (
      <Footer
        total={ReceivedDiamondData?.length}
        currentIndex={currentIndex}
        hasArrow={Platform.OS === "web" && theme.isLargeScreen}
        leftClickEvent={leftItemLeftClickEvent}
        rightClickEvent={leftItemRightClickEvent}
        imageWidth={actualImageWidth}
      />
    );
  };

  const leftItemLeftClickEvent = () => {
    if (leftCurrentIndex !== 0) {
      setLeftCurrentIndex(leftCurrentIndex - 1);
    }
  };

  const leftItemRightClickEvent = () => {
    if (leftCurrentIndex < ReceivedDiamondData?.length - 1) {
      setLeftCurrentIndex(leftCurrentIndex + 1);
    }
  };

  return (
    <ViewContainer>
      <ImageGallery
        images={ReceivedDiamondData}
        resizeMode="cover"
        isOpen={Platform.OS === "web"}
        initialIndex={leftCurrentIndex}
        renderFooterComponent={renderFooterComponent}
        thumbColor={theme["core-06"]}
        isExternalView={GalleryCategory.productDetail}
        thumbDefaultBorderColor={theme["core-03"]}
        image_thumb_url={itemDetail?.image_thumb_url}
        productType={productType}
        itemDetail={itemDetail}
        isClickable={true}
        showExpand={showExpandButton}
        applyRadius={theme.isLargeScreen}
        isSmallDeviceWidth={!theme.isMobile}
        imageWidth={actualImageWidth ?? screenWidth}
        scrollEnabled={
          ReceivedDiamondData?.length === 1 ||
          (Platform.OS === "web" && theme.isLargeScreen)
            ? false
            : true
        }
        resizeImage={!theme.isMobile}
        isMatchModel={false}
        isSmallVideoView={true}
        GIACertEnable={true}
        thumbSize={dimensions?.thumbSize}
        iconSize={dimensions?.iconSize}
        hideThumbs={hideThumbs}
        setMediaActiveIndex={setMediaActiveIndex}
        mediaActiveIndex={mediaActiveIndex}
        fromReviewPage={fromReviewPage}
        isJewelryComponent={isJewelryComponent}
        onRemoveMedia={onRemoveMedia}
        isModal={isModal}
        onShareViaNativeFromModal={onShareViaNativeFromModal}
        hideMediaActions={hideMediaActions}
      />
    </ViewContainer>
  );
};

const ViewContainer = styled.View`
  padding-left: 0px;
  padding-right: 0px;
  padding-top: ${({ theme }) =>
    !theme.isMobile ? SpaceType.Double + "px" : 0};
  background-color: ${({ theme }) =>
    theme.isMobile ? theme["core-01"] : "transparent"};
  ${({ theme }) =>
    !theme.isMobile &&
    Platform.OS === "web" &&
    css`
      position: sticky;
      top: 0;
    `}
`;

export default PDPGalleryView;
